import store from "@/store";
import axios from "axios";
import router from "@/router/index";
import { Message } from "element-ui";
import util from "@/libs/util";
import loading from "@/libs/loading";
import message from "@/libs/message";
import permission from "@/libs/permission";
import { validateNull } from "@/api/czManager/czCaseInfo/index";

import { renderAsync } from "docx-preview";
// 记录和显示错误
function errorLog(err) {
  // 添加到日志
  store.dispatch("d2admin/log/add", {
    type: "error",
    err,
    info: "数据请求异常",
  });
  // 打印到控制台
  if (process.env.NODE_ENV === "development") {
    util.log.danger(">>>>>> Error >>>>>>");
    console.log(err);
  }
  // 显示提示
  Message({
    message: err.message,
    type: "error",
    duration: 5 * 1000,
  });
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 120000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    if (!permission.access(config, store)) {
      // eslint-disable-next-line no-throw-literal
      throw {
        type: "403",
        config: config,
      };
    }
    loading.show(config);
    // 在请求发送之前做一些处理
    if (!/^https:\/\/|http:\/\//.test(config.url)) {
      const token = util.cookies.get("token");
      if (token && token !== "undefined") {
        // 让每个请求携带token-- ['Authorization']为自定义key 请根据实际情况自行修改
        config.headers["Authorization"] = "Bearer " + token;
      }
    }
    return config;
  },
  (error) => {
    // 发送失败
    console.log(error);
    Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    loading.hide(response.config);
    const res = response.data;
    if (
      res.statusCode !== 200 &&
      res.statusCode != 2000 &&
      res.data != undefined
    ) {
      Message({
        message: res.message,
        type: "error",
        duration: 3 * 1000,
      });
      return Promise.reject(res.message);
    } else {
      message(response.config);
      if (res.data != undefined && res.data != null) {
        return res.data;
      } else {
        return res;
      }
    }
  },
  (error) => {
    console.log(error);
    loading.hide(error.config);
    if (error.response && error.response.status === 401) {
      util.cookies.remove();
      if (error.config.url.indexOf("logout") === -1) {
        Message({
          message: "登陆信息已过期,请重新登陆!",
          type: "error",
          duration: 3 * 1000,
        });
      }
      setTimeout(() => {
        // 删除cookie
        util.cookies.remove("token");
        util.cookies.remove("uuid");
        // 跳转路由
        router.push({
          name: "login",
        });
      }, 1000);
    } else if (error.response && error.response.status === 500) {
      errorLog(new Error(`系统错误!: ${error.config.url}`));
    } else if (error.message && error.message.indexOf("timeout") > -1) {
      errorLog(new Error(`网络超时!: ${error.config.url}`));
    } else if (error.response.status === 403) {
      errorLog(new Error(`权限不足，请通知管理员!`));
    } else {
      errorLog(new Error(`网络错误!: ${error.config.url}`));
    }
    return Promise.reject(error);
  }
);

export function uploadFile(that, uploadObj, req, callBack, refCom) {

  let loading = that.$loading({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  const token = util.cookies.get("token");
  let keyArr = Object.entries(uploadObj);
  for (let i = 0; i < keyArr.length; i++) {
    if (keyArr[i][0] !== "fileList") {
      that.fileData.append(keyArr[i][0], keyArr[i][1]);
      console.log(keyArr[i][0], keyArr[i][1]);
    } else {
      // that.fileData.append('file',keyArr[i][1])
    }
  }

  // refCom.submit();
  return axios({
    url: process.env.VUE_APP_API + req.url,
    method: req.method ? req.method : "post",
    dataType: "json",
    responseType: "application/json",
    data: that.fileData,
    headers: {
      authorization: "Bearer " + token,
    },
  })
    .then((res) => {
      loading.close();
      that.fileData = new FormData();
      that.$message.success("成功");
      that.getList();
      that.btFlag = false;

      callBack(res);

      if (res.data.statusCode === 2000) {
        that.fileLen = 0;
        // callBack(res);
        for (let key in uploadObj) {
          if (key != "fileList") {
            uploadObj[key] = "";

          } else if (key == "fileList") {
            uploadObj[key] = [];
          }
        }
        that.fileList = []
      }

    })
    .catch((err) => {
      that.$message.error("上传失败");
      that.fileLen = 0;
    });
}

export function getPreviewFile(that, req) {
  const documentType = {
    // img:
    png: "image/png",
    jpeg: "image/jpeg",
    docx: "application/msword",
  };
  let loading = that.$loading({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgba(0, 0, 0, 0.7)",
  });
  if (req.requireValidate) {
    validateNull(form).then((response) => {
      if (response.statusCode !== 2000) {
        that.showDoc = false;
        that.$message({
          message: "无法获取预览数据：" + response.message,
        });
        return;
      } else {
        that.showDoc = true;
        const token = util.cookies.get("token");
        axios({
          url: process.env.VUE_APP_API + req.url,
          method: req.method ? req.method : "post",
          responseType: "arraybuffer",
          data: req.data,
          headers: {
            // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
            authorization: "Bearer " + token,
          },
        }).then((res) => {
          loading.close();
          const disposition = res.headers["content-disposition"];
          const fileName = decodeURI(disposition);
          const blob = new Blob([res.data]);
          let url = window.URL.createObjectURL(
            new File([res.data], { type: "application/msword" })
          );
          that.$message({
            message: "成功",
            type: "success",
          });
          // console.log(res, "ssssssssssssssssss");
          that.docx = url;
          let docxOptions = {
            inWrapper: false, // boolean：启用围绕文档内容的包装器渲染
            ignoreWidth: false, // boolean：禁用页面的渲染宽度
            ignoreHeight: false, // boolean：禁止渲染页面高度
            ignoreFonts: false, // boolean：禁用字体渲染
            breakPages: true, // boolean：在分页符上启用分页
            ignoreLastRenderedPageBreak: false, // boolean：在 lastRenderedPageBreak 元素上禁用分页
            experimental: true, // boolean：启用实验功能（制表符停止计算）
            trimXmlDeclaration: false, // boolean：如果为true，解析前会从​​ xml 文档中移除 xml 声明
            useBase64URL: false,
            useMathMLPolyfill: false,
            showChanges: false,
            debug: false,
          };

          // that.docx = `http://localhost:9572/image/aaz.docx`
          //  const blob = new Blob([that.docx],{type:"application/msword"})
          let childRef = document.getElementsByClassName("docxRef");
          renderAsync(blob, childRef[0], null, docxOptions);
        });
      }
    });
  } else {
    that.showDoc = true;
    const token = util.cookies.get("token");
    axios({
      url: process.env.VUE_APP_API + req.url,
      method: req.method ? req.method : "post",
      responseType: "arraybuffer",
      data: req.data,
      headers: {
        // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
        authorization: "Bearer " + token,
      },
    }).then((res) => {
      loading.close();
      const disposition = res.headers["content-disposition"];
      const fileName = decodeURI(disposition);
      const blob = new Blob([res.data]);
      let url = window.URL.createObjectURL(
        new File([res.data], { type: documentType[req.type] })
      );
      that.$message({
        message: "成功",
        type: "success",
      });
      // console.log(res, "ssssssssssssssssss");
      that.docx = url;
      let docxOptions = {
        inWrapper: false, // boolean：启用围绕文档内容的包装器渲染
        ignoreWidth: false, // boolean：禁用页面的渲染宽度
        ignoreHeight: false, // boolean：禁止渲染页面高度
        ignoreFonts: false, // boolean：禁用字体渲染
        breakPages: true, // boolean：在分页符上启用分页
        ignoreLastRenderedPageBreak: false, // boolean：在 lastRenderedPageBreak 元素上禁用分页
        experimental: true, // boolean：启用实验功能（制表符停止计算）
        trimXmlDeclaration: false, // boolean：如果为true，解析前会从​​ xml 文档中移除 xml 声明
        useBase64URL: false,
        useMathMLPolyfill: false,
        showChanges: false,
        debug: false,
      };

      // that.docx = `http://localhost:9572/image/aaz.docx`
      //  const blob = new Blob([that.docx],{type:"application/msword"})
      let childRef = document.getElementsByClassName("docxRef");
      renderAsync(blob, childRef[0], null, docxOptions);
    });
  }
}

/**
 *
 * @param {*} that
 * @param {*} req
 * @param {*} callBack
 * @returns
 */
export function downLoadFile(that, req, callBack) {
  console.log(req)
  let fileNum = req.fileNum >= 0 ? req.fileNum : 1;
  let formData = new FormData();
  //案件类校验
  if (that.caseIdList) {
    if (that.caseIdList.length < fileNum && !req.requireSelect) {
      that.$message.error("请勾选至少" + fileNum + "个案件");
      return;
    }
    formData.append("caseIdList", that.caseIdList);
  }
  //文件类校验
  if (that.fileIdList) {
    if (that.fileIdList.length < fileNum) {
      that.$message.error("请勾选至少" + fileNum + "一项文书");
      return;
    }
    formData.append("fileIdList", that.fileIdList);
  }

  const token = util.cookies.get("token");
  let loading = undefined;

  if (req.isValidate) {
    req = callBack(req);
    loading = that.$loading({
      lock: true,
      text: "正在生成文件",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    axios({
      url: process.env.VUE_APP_API + req.url,
      method: req.method ? req.method : "post",
      responseType: "arraybuffer",
      data: formData,
      paramsSerializer: function (params) {
        let result = [];
        for (let field in params) {
          if (params[field] === undefined || params[field] === null) {
            result.push(`${field}=`);
            continue;
          }
          if (Array.isArray(params[field])) {
            result.push(params[field].map((_) => `${field}=${_}`).join("&"));
          } else {
            result.push(`${field}=${encodeURIComponent(params[field])}`);
          }
        }
        return result.join("&");
      },
      headers: {
        // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
        authorization: "Bearer " + token,
      },
    })
      .then((res) => {
        loading.close();
        const disposition = res.headers["content-disposition"];
        const fileName = decodeURI(disposition);
        let url = window.URL.createObjectURL(
          new Blob([res.data], { type: req.fileType ? req.fileType : ".zip" })
        );
        let a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        url = window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch((res) => {
        loading.close();
      });
    return;
  } else {
    loading = that.$loading({
      lock: true,
      text: "正在验证案件",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    validateNull(formData).then((response) => {
      loading.close();
      if (response.statusCode === 2000) {
        req = callBack(req);

        loading = that.$loading({
          lock: true,
          text: "正在生成文件",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        axios({
          url: process.env.VUE_APP_API + req.url,
          method: req.method ? req.method : "post",
          responseType: "arraybuffer",
          params: req.params,
          data: req.data,
          paramsSerializer: function (params) {
            let result = [];
            for (let field in params) {
              if (params[field] === undefined || params[field] === null) {
                result.push(`${field}=`);
                continue;
              }
              if (Array.isArray(params[field])) {
                result.push(
                  params[field].map((_) => `${field}=${_}`).join("&")
                );
              } else {
                result.push(`${field}=${encodeURIComponent(params[field])}`);
              }
            }
            return result.join("&");
          },
          headers: {
            // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
            authorization: "Bearer " + token,
          },
        })
          .then((res) => {
            loading.close();
            const disposition = res.headers["content-disposition"];
            const fileName = decodeURI(disposition);
            let url = window.URL.createObjectURL(
              new Blob([res.data], {
                type: req.fileType ? req.fileType : ".zip",
              })
            );
            let a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.setAttribute("download", fileName);
            document.body.appendChild(a);
            a.click();
            url = window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          })
          .catch((res) => {
            loading.close();
          });
      } else {
        that.$message.error(response.message);
      }
    });
  }
}




export function downLoadExcel(that, req, callBack) {
  console.log(req)
  let fileNum = req.fileNum >= 0 ? req.fileNum : 1;
  that.CaseInfo.caseIdList = that.caseIdList

  const token = util.cookies.get("token");
  let loading = undefined;

  if (req.isValidate) {
    req = callBack(req);
    loading = that.$loading({
      lock: true,
      text: "正在生成文件",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    axios({
      url: process.env.VUE_APP_API + req.url,
      method: req.method ? req.method : "post",
      responseType: "arraybuffer",
      data: that.CaseInfo,
      paramsSerializer: function (params) {
        let result = [];
        for (let field in params) {
          if (params[field] === undefined || params[field] === null) {
            result.push(`${field}=`);
            continue;
          }
          if (Array.isArray(params[field])) {
            result.push(params[field].map((_) => `${field}=${_}`).join("&"));
          } else {
            result.push(`${field}=${encodeURIComponent(params[field])}`);
          }
        }
        return result.join("&");
      },
      headers: {
        // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
        authorization: "Bearer " + token,
      },
    })
      .then((res) => {
        loading.close();
        const disposition = res.headers["content-disposition"];
        const fileName = decodeURI(disposition);
        let url = window.URL.createObjectURL(
          new Blob([res.data], { type: req.fileType ? req.fileType : ".zip" })
        );
        let a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.setAttribute("download", fileName);
        document.body.appendChild(a);
        a.click();
        url = window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      })
      .catch((res) => {
        loading.close();
      });
    return;
  } else {
    loading = that.$loading({
      lock: true,
      text: "正在验证案件",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    validateNull(formData).then((response) => {
      loading.close();
      if (response.statusCode === 2000) {
        req = callBack(req);

        loading = that.$loading({
          lock: true,
          text: "正在生成文件",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        axios({
          url: process.env.VUE_APP_API + req.url,
          method: req.method ? req.method : "post",
          responseType: "arraybuffer",
          params: req.params,
          data: req.data,
          paramsSerializer: function (params) {
            let result = [];
            for (let field in params) {
              if (params[field] === undefined || params[field] === null) {
                result.push(`${field}=`);
                continue;
              }
              if (Array.isArray(params[field])) {
                result.push(
                  params[field].map((_) => `${field}=${_}`).join("&")
                );
              } else {
                result.push(`${field}=${encodeURIComponent(params[field])}`);
              }
            }
            return result.join("&");
          },
          headers: {
            // 项目中请求头需要的信息（如果不需要可不写），如用户登录信息验证：
            authorization: "Bearer " + token,
          },
        })
          .then((res) => {
            loading.close();
            const disposition = res.headers["content-disposition"];
            const fileName = decodeURI(disposition);
            let url = window.URL.createObjectURL(
              new Blob([res.data], {
                type: req.fileType ? req.fileType : ".zip",
              })
            );
            let a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.setAttribute("download", fileName);
            document.body.appendChild(a);
            a.click();
            url = window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
          })
          .catch((res) => {
            loading.close();
          });
      } else {
        that.$message.error(response.message);
      }
    });
  }
}

export default service;
